var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcFolderAdd = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0498 13.7502V9.5835",
    stroke: "#818181",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0832 11.6665H7.9165",
    stroke: "#818181",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 9.1665V14.1665C18.3332 17.4998 17.4998 18.3332 14.1665 18.3332H5.83317C2.49984 18.3332 1.6665 17.4998 1.6665 14.1665V5.83317C1.6665 2.49984 2.49984 1.6665 5.83317 1.6665H7.08317C8.33317 1.6665 8.60817 2.03317 9.08317 2.6665L10.3332 4.33317C10.6498 4.74984 10.8332 4.99984 11.6665 4.99984H14.1665C17.4998 4.99984 18.3332 5.83317 18.3332 9.1665Z",
    stroke: "#818181",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcFolderAdd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icFolderAdd.ccbbfcf5.svg";
export { ForwardRef as ReactComponent };